import { useRef, useState } from "react";
import CustomSelect from "../../shared/CustomSelect";
import { Upload } from "lucide-react";
import { uploadMultiImages } from "../../sdk/upload/upload";
import LoanApplicationModal from "../../shared/LoanApplicationModal";

const Payslips = ({
  closePayslips,
  activeIndex,
  handleNextStep,
  setPayslips,
  loading,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    try {
      const uploadedUrls = await uploadMultiImages(files);
      setPayslips(uploadedUrls);
    } catch (err) {
      console.error("Failed to upload files:", err);
    }
    setSelectedFiles(files);
  };

  const handleChooseFileClick = () => {
    fileInputRef.current?.click();
  };
  return (
    <LoanApplicationModal
      closeBioInformation={closePayslips}
      activeIndex={activeIndex}
      handleNextStep={handleNextStep}
      loading={loading}
    >
      <p className="text-[#000000] font-normal text-[14px]">
        Create a New Loan Application
      </p>
      <p className="text-[#000000] font-semibold text-[20px]">
        Borrower’s Income Details
      </p>
      <p className="text-[#5C5C5C] text-[14px] font-normal">
        Upload latest payslips
      </p>
      <div className="flex items-start gap-[20px] my-[10px]">
        <div className="flex w-[100%] flex-col">
          <label
            className="text-[#222222] font-medium text-[12px] truncate"
            htmlFor="Payslip Type"
          >
            Payslip Type
          </label>
          <CustomSelect
            name="Payslip Type"
            onChange={(e) => {}}
            options={["3 months", "6 months"]}
          />
        </div>
      </div>
      <div className="flex w-[100%] my-[20px] flex-col">
        <p className="text-[#222222] font-medium text-[13px]">
          Payslips{" "}
          <span className="font-normal text-[#5C5C5C]">
            .jpeg or .png file only
          </span>
        </p>
        <div
          className="min-h-[90px] px-[10px] py-[12px] flex flex-col gap-[10px] rounded-[8px] border-[0.7px] border-[#A8A8A8] bg-white cursor-pointer"
          onClick={handleChooseFileClick}
        >
          {selectedFiles.length > 0 ? (
            <div className="flex flex-wrap gap-[10px]">
              {selectedFiles.map((file, index) => (
                <div
                  key={index}
                  className="min-w-[120px] px-[8px] py-[6px] rounded-[6px] bg-[#F9F9F9] border border-[#DDD] text-center"
                >
                  <p className="text-[12px] font-semibold text-black truncate">
                    {file.name}
                  </p>
                  <p className="text-[11px] text-gray-500">
                    {(file.size / 1024).toFixed(2)} KB
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <>
              <Upload />
              <p className="text-[#000000] text-[12px] font-normal">
                Drag and Drop file here or{" "}
                <span className="text-[#000000] underline">Choose file</span>{" "}
                here
              </p>
            </>
          )}
          <input
            type="file"
            multiple
            ref={fileInputRef}
            className="hidden"
            onChange={handleFileChange}
          />
        </div>
      </div>
    </LoanApplicationModal>
  );
};

export default Payslips;
